import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExportMenu from "../../../Common/ExportMenu/ExportMenu";

const EXPORT_COLUMNS = [
  "S.No",
  "Zone",
  "Ward No",
  "Name",
  "Mobile No",
  "Login ID",
  "Level",
  "Alert Before Escalation",
  "Escalation Duration",
  "Status",
];

const mapRowsForExport = (data = []) =>
  data.map((row, index) => [
    index + 1,
    row.zoneName || "N/A",
    row.wardNo || row.wardName || "N/A",
    row.userName || "N/A",
    row.mobileNo || "N/A",
    row.loginId || "N/A",
    row.level || "N/A",
    row.alertBeforeEscalationMin
      ? `${row.alertBeforeEscalationMin} Minutes`
      : "N/A",
    row.escalationDurationMin
      ? `${row.escalationDurationMin} Minutes`
      : "N/A",
    row.isActive ? "Active" : "Inactive",
  ]);

export const ExportSlaUserMatrix = ({ slaUserMatrixData = [] }) => {
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SLA User Matrix");
    const boldFont = { bold: true };

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `SLA User Matrix Generated on: ${formattedDate}, ${formattedTime}`;

    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, EXPORT_COLUMNS.length);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    worksheet.addRow(["", "", "SLA User Matrix List", ""]);
    worksheet.mergeCells(2, 2, 2, EXPORT_COLUMNS.length);
    worksheet.getCell(2, 2).value = "SLA User Matrix List";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    const tableHeaderRow = worksheet.addRow(EXPORT_COLUMNS);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= EXPORT_COLUMNS.length) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "003366" },
        };
      }
    });

    mapRowsForExport(slaUserMatrixData).forEach((row) => {
      worksheet.addRow(row).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: "center" };
      });
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "SlaUserMatrix.xlsx";
      anchor.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  const exportToPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `SLA User Matrix Generated on: ${formattedDate} ${formattedTime}`;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("SLA User Matrix List", 14, 20);
    doc.setFontSize(10);
    doc.text(downloadDateTime, 14, 28);

    autoTable(doc, {
      startY: 35,
      head: [EXPORT_COLUMNS],
      body: mapRowsForExport(slaUserMatrixData),
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
        valign: "middle",
      },
      headStyles: {
        fillColor: [0, 51, 102],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      bodyStyles: {
        fontSize: 8,
        halign: "left",
      },
    });

    doc.save("SlaUserMatrix.pdf");
  };

  return (
    <div className="ms-3">
      <ExportMenu
        items={[
          { label: "Excel", icon: "fa-solid fa-file-excel", onClick: exportToExcel },
          { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: exportToPDF },
        ]}
      />
    </div>
  );
};
